var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80539 7.6201C10.7708 7.6201 12.364 6.04862 12.364 4.1101C12.364 2.17158 10.7708 0.600098 8.80539 0.600098C6.84002 0.600098 5.24677 2.17158 5.24677 4.1101C5.24677 6.04862 6.84002 7.6201 8.80539 7.6201Z",
    fill: "#667A8C",
    stroke: "#667A8C",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.345 16.4002C16.0142 16.4002 16.5312 15.7602 16.3183 15.1202C15.2943 11.9902 12.3237 9.72021 8.80565 9.72021C5.28758 9.72021 2.31699 11.9902 1.293 15.1202C1.09023 15.7502 1.59715 16.4002 2.2663 16.4002H15.345Z",
    fill: "#667A8C",
    stroke: "#667A8C",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.4afc00620d01c577d04a67fecc94def3.svg";
export { ForwardRef as ReactComponent };